import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const Marketplace = () => {
    return (
        <div className="px-2 sm:px-4 lg:px-8 py-5 lg:py-7 h-full overflow-hidden">
            <div className="p-4 bg-white w-full ">
                <div className="mb-3.5">
                    <h1 className="text-2xl font-bold text-ebony-color">
                        Marketplace
                    </h1>
                </div>

                <div className=" mb-4">
                    <ul className="flex items-center space-x-5 pb-[7px] border-b border-black-10">
                        <li>
                            <NavLink
                                to="/marketplace/liveStreams"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize marketplace-nav"
                            >
                                LiveStream
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/marketplace/products"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize marketplace-nav"
                            >
                                product
                            </NavLink>
                        </li>
                    </ul>
                </div>

                <div className=" h-[calc(100vh_-_290px)] md:h-[calc(100vh_-_260px)] overflow-y-auto">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Marketplace;
